export default async ({ store }) => {
    if (!store.state.cacheVersion) {
        await store.dispatch('loadCacheVersion');
    }
}
